import { request } from '../request';

/**
 * GET /job-postings
 * 查询公开招聘岗位列表
 *
 * @param params 筛选与分页参数 (category_code, keyword, page, page_size)
 * @returns 招聘岗位分页数据 (marketdto.JobPageResponse)
 */
export function fetchPublicJobPostings(params?: Api.Job.QueryJobPostingsParams) {
  return request<Api.Job.JobPageResponse>({
    url: '/job-postings',
    method: 'get',
    params
  });
}

/**
 * POST /job-postings
 * 创建或更新招聘草稿 (创建招聘草稿)
 *
 * @param data 招聘岗位草稿提交数据 (marketdto.JobRequest)
 * @returns 招聘岗位详情 (marketdto.JobResponse)
 */
export function createJobPostingDraft(data: Api.Job.JobRequest) {
  return request<Api.Job.JobResponse>({
    url: '/job-postings',
    method: 'post',
    data
  });
}

/**
 * GET /job-postings/{id}
 * 获取公开招聘岗位详情
 *
 * @param id 招聘 ID
 * @returns 招聘岗位详情 (marketdto.JobResponse)
 */
export function fetchPublicJobPostingDetail(id: string) {
  return request<Api.Job.JobResponse>({
    url: `/job-postings/${id}`,
    method: 'get'
  });
}

/**
 * PUT /job-postings/{id}
 * 创建或更新招聘草稿 (更新招聘草稿)
 *
 * @param id 用于更新的招聘 ID
 * @param data 招聘岗位草稿更新数据 (marketdto.JobRequest)
 * @returns 招聘岗位详情 (marketdto.JobResponse)
 */
export function updateJobPostingDraft(id: string, data: Api.Job.JobRequest) {
  return request<Api.Job.JobResponse>({
    url: `/job-postings/${id}`,
    method: 'put',
    data
  });
}

/**
 * POST /job-postings/{id}/close
 * 关闭招聘岗位
 *
 * @param id 招聘 ID
 * @returns 招聘岗位详情 (marketdto.JobResponse)
 */
export function closeJobPosting(id: string) {
  return request<Api.Job.JobResponse>({
    url: `/job-postings/${id}/close`,
    method: 'post'
  });
}

/**
 * GET /my/job-postings
 * 查询我发布的招聘岗位
 *
 * @param params 筛选与分页参数 (status, keyword, page, page_size)
 * @returns 我发布的招聘岗位分页数据 (marketdto.JobPageResponse)
 */
export function fetchMyJobPostings(params?: Api.Job.QueryMyJobPostingsParams) {
  return request<Api.Job.JobPageResponse>({
    url: '/my/job-postings',
    method: 'get',
    params
  });
}

/**
 * POST /job-postings/{id}/submit
 * 提交招聘审核
 *
 * @param id 招聘 ID
 * @returns 招聘岗位详情 (marketdto.JobResponse)
 */
export function submitJobPostingAudit(id: string) {
  return request<Api.Job.JobResponse>({
    url: `/job-postings/${id}/submit`,
    method: 'post'
  });
}

